import styled from 'styled-components'

export const PopupVisibilityUi = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`
